export const REMERCHANDISE_START = 'REMERCHANDISE_START';
export const REMERCHANDISE_SUCCESS = 'REMERCHANDISE_SUCCESS';
export const REMERCHANDISE_FAILED = 'REMERCHANDISE_FAILED';
export const RESET_REMERCHANDISE = 'RESET_REMERCHANDISE';

export interface RemerchRequest {  
  firstName: string;
  email: string;
  tripStartDate: string;
  language: string;
}

export interface RemerchCreateStore {
  createPending?: boolean;
  response?: RemerchRequest;
  error?: unknown;
  loading?: boolean;
}

export interface RemerchCreateAction {
  type: string;
  payload?: RemerchRequest;
}
